<template>
  <div class="widget-powered-by">
    <span>{{ $t('widgetFooter.text') }}</span>

    <a
      :href="textMagicLink"
      target="_blank"
      class="d-flex align-center"
    >
      <img
        src="@/assets/images/logo-with-text.svg"
        class="widget-powered-by__logo"
        alt="logo"
      />
    </a>
  </div>
</template>

<script setup lang="ts">
import { textMagicLink } from '@widgets/shared/const'
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables.scss';

.widget-powered-by {
  font-size: 11px;
  line-height: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $light;
  font-weight: $semi-bold-font;
  padding: 13px;

  &__logo {
    height: 12px;
    margin-left: 4px;
    margin-top: 2px;
  }
}
</style>
